import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchMd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.33301 2.66665C4.75568 2.66665 2.66634 4.75598 2.66634 7.33331C2.66634 9.91064 4.75568 12 7.33301 12C8.5903 12 9.73147 11.5028 10.5706 10.6942C10.5881 10.6714 10.6074 10.6495 10.6283 10.6286C10.6492 10.6077 10.6711 10.5885 10.6939 10.5709C11.5025 9.73178 11.9997 8.59061 11.9997 7.33331C11.9997 4.75598 9.91034 2.66665 7.33301 2.66665ZM12.0209 11.0784C12.842 10.052 13.333 8.74999 13.333 7.33331C13.333 4.0196 10.6467 1.33331 7.33301 1.33331C4.0193 1.33331 1.33301 4.0196 1.33301 7.33331C1.33301 10.647 4.0193 13.3333 7.33301 13.3333C8.74968 13.3333 10.0517 12.8423 11.0781 12.0212L13.5283 14.4714C13.7886 14.7317 14.2107 14.7317 14.4711 14.4714C14.7314 14.211 14.7314 13.7889 14.4711 13.5286L12.0209 11.0784Z",
		fill: "currentColor"
	})
});
export default SvgSearchMd;
